export default {"src":"/_next/static/media/Verona.27b6c4fc.svg","height":200,"width":196,"blurWidth":0,"blurHeight":0};